import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { NotificationModule } from 'libraries/component/notification/notification.module';

import { GoogleMapComponent } from './googleMap.component';
import { GoogleMapApiLoaderService } from './googleMapApiLoader.service';
import { MapComputationModule } from '../computation/map-computation.module';

@NgModule({
    imports: [
        CommonModule,
        NotificationModule,
        MapComputationModule,
        FormsModule,
    ],
    declarations: [
        GoogleMapComponent,
    ],
    exports: [
        GoogleMapComponent,
    ],
    providers: [
        GoogleMapApiLoaderService,
    ],
})
export class GoogleMapModule { }